import { Link } from 'react-router-dom';

export default function ReviewSection() {
  return (
    <section className="py-16 md:py-24 bg-background-100">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="flex flex-col lg:flex-row gap-10 lg:gap-16 items-center">
          <div className="lg:w-[40%]">
            <div className="rounded-3xl overflow-hidden aspect-[4/5] bg-background-200">
              <img
                src="https://readdy.ai/api/search-image?query=Smiling%20young%20European%20person%20using%20laptop%20in%20bright%20minimalist%20room%2C%20warm%20natural%20lighting%20through%20large%20window%2C%20casual%20stylish%20neutral%20clothing%2C%20clean%20modern%20interior%20with%20cream%20walls%2C%20genuine%20happy%20expression%2C%20lifestyle%20photography%2C%20Scandinavian%20aesthetic%2C%20no%20clutter&width=800&height=1000&seq=review-img-v3&orientation=portrait"
                alt="Kakobuy Spreadsheet review"
                className="w-full h-full object-cover object-top"
              />
            </div>
          </div>

          <div className="lg:w-[55%]">
            <span className="text-xs text-foreground-500 font-medium tracking-wider uppercase mb-4 block">
              (Recenzja 2026)
            </span>
            <h2 className="text-3xl md:text-4xl lg:text-5xl font-heading font-bold text-foreground-950 leading-tight mb-1">
              Kakobuy Spreadsheet
            </h2>
            <p className="text-xl md:text-2xl font-heading text-secondary-500 mb-8">
              to Najlepszy Wybór dla Polski
            </p>

            <blockquote className="text-sm md:text-base text-foreground-600 leading-relaxed mb-6 pl-4 border-l-2 border-accent-400 italic">
              &ldquo;Kakobuy Spreadsheet Polska to najlepszy spos&oacute;b na znalezienie produkt&oacute;w na Kakobuy. Best Kakobuy Spreadsheet 2026 oferuje aktualne listy, por&oacute;wnania i rekomendacje dla użytkownik&oacute;w z Polski.&rdquo;
            </blockquote>

            <p className="text-sm text-foreground-800 font-semibold mb-4">
              &mdash; Ekspert KakoBuy
            </p>

            <p className="text-sm text-foreground-600 leading-relaxed mb-6 max-w-lg">
              Nasz <Link to="/kakobuy-spreadsheet-polska/" className="text-primary-600 hover:text-primary-700 underline underline-offset-2 font-medium">Kakobuy Spreadsheet Polska</Link> został stworzony z myślą o polskich użytkownikach, oferując najlepsze listy produkt&oacute;w i{' '}
              <Link to="/best-kakobuy-spreadsheet-2026/" className="text-primary-600 hover:text-primary-700 underline underline-offset-2 font-medium">Best Kakobuy Spreadsheet 2026</Link> dla wszystkich entuzjast&oacute;w zakup&oacute;w.
            </p>

            <div className="flex items-center gap-3">
              <button
                type="button"
                className="w-10 h-10 rounded-full border border-foreground-200 flex items-center justify-center text-foreground-400 hover:border-foreground-400 hover:text-foreground-600 transition-colors cursor-pointer"
                aria-label="Poprzednia recenzja"
              >
                <i className="ri-arrow-left-line"></i>
              </button>
              <button
                type="button"
                className="w-10 h-10 rounded-full bg-foreground-950 flex items-center justify-center text-background-50 hover:bg-foreground-800 transition-colors cursor-pointer"
                aria-label="Następna recenzja"
              >
                <i className="ri-arrow-right-line"></i>
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}